module.exports = __webpack_public_path__ + "static/media/2.ebf65ed7.jpg";